import { createStore } from 'effector';
import { logoutSucceeded } from '../auth';
import { type ProcessingMode } from './model';
import { setProcessingMode } from './events';

export const $processingMode = createStore<ProcessingMode>('payin')
    .on(setProcessingMode, (_, mode) => {
        return mode;
    })
    .reset(logoutSucceeded);
